<template>
	<el-dialog title="路线销售目标设置" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="630px">
		<div class="form-box">
			<div class="title">
				<div>
					周期：
					<el-select v-model="dataForm.year" class="w190" size="small" @change="changeYear">
						<el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div>路线：{{ routeName }}</div>
			</div>
			<el-form :model="dataForm" :rules="rules" ref="dataForm">
				<div class="flex flex-between">
					<el-form-item label="月份" prop="month" label-width="80px">
						<el-select v-model="dataForm.month" class="w190" size="small" placeholder="请选择月份" @change="handleChange" clearable>
							<el-option
								v-for="item in monthlist"
								:key="item.value"
								:label="item.label"
								:value="item.value"
								:disabled="item.disabled"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="销售目标瓶数" prop="number" label-width="120px">
						<el-input v-model.trim="dataForm.number" class="w190" size="small" placeholder="销售目标瓶数" maxlength="9" clearable></el-input>
					</el-form-item>
				</div>
			</el-form>
			<div class="actual-info">
				<div>上年同期实绩：{{ lastYearActual }}</div>
				<div>上月实绩：{{ lastMonthActual }}</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible = false">取 消</el-button>
			<el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
export default {
	data() {
		return {
			dialogVisible: false,
			year: new Date().getFullYear(),
			routeId: "",
			routeName: "",
			monthlist: [
				{ label: "一月", value: "1" },
				{ label: "二月", value: "2" },
				{ label: "三月", value: "3" },
				{ label: "四月", value: "4" },
				{ label: "五月", value: "5" },
				{ label: "六月", value: "6" },
				{ label: "七月", value: "7" },
				{ label: "八月", value: "8" },
				{ label: "九月", value: "9" },
				{ label: "十月", value: "10" },
				{ label: "十一月", value: "11" },
				{ label: "十二月", value: "12" },
			],
			dataForm: {
				year: "",
				month: "",
				number: "",
			},
			rules: {
				year: [
					{
						required: true,
						message: "请选择年份",
						trigger: "change",
					},
				],
				month: [
					{
						required: true,
						message: "请选择月份",
						trigger: "change",
					},
				],
				number: [
					{
						required: true,
						message: "请输入销售目标瓶数",
						trigger: "blur",
					},
					{
						pattern: /^[1-9]\d*$/,
						message: "销售目标瓶数必须为正整数",
						trigger: "blur",
					},
				],
			},
			dt: {},
			// 上年数据id
			lastYearId: "",
			lastMonthActual: "",
			lastYearActual: "",
			yearList: [],
		};
	},
	methods: {
		init(dt) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				this.routeId = dt.routeId;
				this.routeName = dt.routeName;
				this.dt = dt;
				const year = new Date().getFullYear();
				this.yearList = [
					{ label: year + "年", value: year },
					{ label: year + 1 + "年", value: year + 1 },
				];
				this.dataForm.month = "";
				this.dataForm.number = "";
				this.lastYearId = "";
				this.lastMonthActual = "";
				this.lastYearActual = "";
				this.dataForm.year = year;
				this.monthlistChange();
			});
		},
		// 变更年份
		changeYear() {
			this.dataForm.month = "";
			this.dataForm.number = "";
			this.lastYearId = "";
			this.lastMonthActual = "";
			this.lastYearActual = "";
			this.monthlistChange();
			setTimeout(() => {
				this.$refs.dataForm.clearValidate("month");
			}, 0);
		},
		// 变更月份
		handleChange() {
			if (this.dataForm.month) {
				this.dataForm.number = this.dt[this.dataForm.month] ? this.dt[this.dataForm.month] : "";
			} else {
				this.dataForm.number = "";
			}
			if (this.dataForm.month == "") {
				return;
			}
			let form = {
				routeId: this.routeId,
				cycle: this.dataForm.year,
				month: Number(this.dataForm.month),
			};
			let self = this;
			// 获取上年同期实绩、上月实绩
			self.$request.post("routeGoalInfo", false, form).then((res) => {
				if (res) {
					self.dataForm.number = res.data.target ? res.data.target : "";
					self.lastYearId = res.data.id ? res.data.id : "";
					self.lastYearActual = res.data.lastYearActual ? res.data.lastYearActual : "";
					self.lastMonthActual = res.data.lastMonthActual ? res.data.lastMonthActual : "";
				}
			});
		},
		// 变更月份禁用
		monthlistChange() {
			const year = new Date().getFullYear();
			if (this.dataForm.year == year) {
				const month = new Date().getMonth();
				for (let index = 0; index < this.monthlist.length; index++) {
					if (index <= month) {
						this.monthlist[index].disabled = true;
					} else {
						this.monthlist[index].disabled = false;
					}
				}
			} else {
				for (let index = 0; index < this.monthlist.length; index++) {
					this.monthlist[index].disabled = false;
				}
			}
		},
		// 提交
		handleSubmit: debounce(
			function () {
				if (this.dialogVisible == false) {
					return;
				}
				let form = {
					routeId: this.routeId,
					cycle: this.dataForm.year,
				};
				form.month = this.dataForm.month;
				form.target = this.dataForm.number;
				if (this.lastYearId) {
					form.id = this.lastYearId;
				}
				this.$refs["dataForm"].validate((valid) => {
					if (valid) {
						this.$confirm("是否确认保存？", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
						})
							.then(() => {
								let self = this;
								self.$request.post("routeGoalAdd", true, form).then((res) => {
									if (res) {
										self.dialogVisible = false;
										self.$emit("handleSearch");
										self.$message.success("保存成功");
									}
								});
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
			1000,
			true,
		),
	},
	beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.title {
	display: flex;
	border-bottom: 1px solid #e4e7ed;
	padding-bottom: 5px;
	margin-bottom: 10px;
	div {
		flex: 1;
		font-size: 16px;
		color: #606266;
		padding-left: 5px;
	}
}
::v-deep .el-dialog__body {
	padding-bottom: 0;
}
.actual-info {
	display: flex;
	margin: 10px 0;
	div {
		flex: 1;
		color: #606266;
		padding-left: 5px;
	}
}

.el-form-item {
	margin-bottom: 8px;
}
</style>
